import {GetterTree} from "vuex";
import {RootState} from "@service/store/types/RootState";
import {groupFilter} from "../../../api/helpers/groupFilter";
import {offsetDiff} from '../../../common/dateTimeHelper';
import {ArrayHelpers} from "../../../common/ArrayHelpers";
import { sessionKey } from "../../helpers/sessionHelper";
import { UserProfile } from "@api/models/UserProfile";

const getters: GetterTree<RootState, RootState> = {
  userId: state => state.session.userId || null,
  profile: state => state.session.profile || null,
  userProfileId: state => state.session.profile?.id || null,
  isAuthed: (state, _, __, rootGetters) => {
    return !!state.session.profile?.id || (!!state.session.sessionId && rootGetters.useAnonym)
  },
  /**
   * app might me used anonymously
   */
  useAnonym: (_, getters) => getters['services/getServiceParam']('anonymousUsing', 'isEnabled'),
  groupIds: state => state.session.profile?.groupIds ?? [],
  groupFilter: state => {
    return state.session.profile?.groupIds ? groupFilter(state.session.profile?.groupIds) : {};
  },
  offsetDiff: state => {
    return offsetDiff(state.timeZoneOffset as number);
  },
  timeRange: (state, getter, rootState, rootGetters) => {
    const timezonesDiff = getter['offsetDiff'],
          selectedEventTimeline = rootGetters['events/selectedEventViewParam']('timeline', {
            begin: 0, end: 24
          }),
          begin = Math.floor(selectedEventTimeline.begin) - timezonesDiff,
          end = Math.floor(selectedEventTimeline.end) - timezonesDiff;
    return {
      begin,
      end
    }
  },
  meetingsTimeRange: (state, getter, rootState, rootGetters) => {
    const selectedEventTimeline = rootGetters['events/selectedEventViewParam']('meetings', {});

    if (!selectedEventTimeline?.timeline?.begin || !selectedEventTimeline?.timeline?.end) {
      return getter['timeRange'];
    }

    const timezonesDiff = getter['offsetDiff'],
          begin = Math.floor(selectedEventTimeline.timeline.begin) - timezonesDiff,
          end = Math.floor(selectedEventTimeline.timeline.end) - timezonesDiff;

    return {
      begin,
      end
    }
  },

  /**
   * concrete user is admin
   */
  userIsAdmin: (_, __, ___, rootGetters) => (profile: UserProfile | undefined) => {
    const adminGroups = rootGetters['services/getServiceParam']('eventsManagement', 'administratorGroupIds') || [];
    return ArrayHelpers.intersect(adminGroups, profile?.groupIds || []).length > 0;
  },
  /**
   * current user is admin
   */
  isAdmin: (state, getters) => {
    return getters.userIsAdmin(state.session.profile);
  },
  isSpeaker: (state, getter, rootState, rootGetters) => {
    return (rootGetters['events/selectedEvent']?.speakers ?? []).includes(state.session.userId);
  },
  localStorageSession: state => () => {
    return JSON.parse(localStorage.getItem(sessionKey(state.session.backend)) || '{}');
  },
  ignoredUserGroupIds: (_, __, ___, rootGetters): string[] | undefined => {
    return rootGetters['services/getServiceParam']('userProfile', 'ignoredUserGroupIds')
  },
  language: (state) => {
    return state.session?.language || navigator.language.split('-')[0] || "en";
  }
};

export {getters}